import { engagementChangelogs } from "../changelogs";
import { engagementAppGroupIdFeatureFlagLimits } from "../engagementAppGroupIdFeatureFlagLimits";
import { engagementAppGroupIdFeatureFlagsInfo } from "../engagementAppGroupIdFeatureFlagsInfo";
import { engagementAppGroupIdHasFeatureFlags } from "../engagementAppGroupIdHasFeatureFlags";
import { engagementAppIdFeatureFlagsEligibilityUserIdDeviceId } from "../engagementAppIdFeatureFlagsEligibilityUserIdDeviceId";
import { engagementFeatureFlagRolloutsData } from "../engagementFeatureFlagRolloutsData";
import { engagementFeatureFlagRolloutsDataFeatureFlagBsonIdAppGroupId } from "../engagementFeatureFlagRolloutsDataFeatureFlagBsonIdAppGroupId";
import type { AllRouteEndpoints } from "../routeTypes";
export const engagementFeatureFlagRolloutUpsertCacheKeys: AllRouteEndpoints[] = [
  engagementFeatureFlagRolloutsData,
  engagementAppGroupIdFeatureFlagLimits,
  engagementAppGroupIdHasFeatureFlags,
  engagementAppGroupIdFeatureFlagsInfo,
  engagementFeatureFlagRolloutsDataFeatureFlagBsonIdAppGroupId,
  engagementAppIdFeatureFlagsEligibilityUserIdDeviceId,
  engagementChangelogs,
];
